import React from "react";

export const PinterestFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 2C12.3179 2 2 12.3179 2 25C2 34.8842 8.26758 43.3303 17.0364 46.577C16.7838 44.3254 16.8234 40.6379 17.2402 38.8526C17.6304 37.1756 19.7614 28.1655 19.7614 28.1655C19.7614 28.1655 19.1181 26.8771 19.1181 24.9744C19.1181 21.9842 20.8505 19.7532 23.0079 19.7532C24.8429 19.7532 25.7277 21.1308 25.7277 22.7814C25.7277 24.6271 24.5543 27.384 23.9465 29.9392C23.4396 32.0801 25.0198 33.8257 27.1301 33.8257C30.9514 33.8257 33.8886 29.7961 33.8886 23.9804C33.8886 18.8328 30.1906 15.2332 24.9091 15.2332C18.7923 15.2332 15.2018 19.8218 15.2018 24.5642C15.2018 26.4116 15.913 28.3929 16.8019 29.4712C16.9772 29.6845 17.0028 29.8706 16.9507 30.0872C16.7878 30.7661 16.4257 32.2265 16.3537 32.5258C16.2603 32.9203 16.0419 33.0021 15.6351 32.8127C12.9493 31.5624 11.2706 27.6371 11.2706 24.4832C11.2706 17.7016 16.1974 11.4724 25.4771 11.4724C32.936 11.4724 38.7319 16.7862 38.7319 23.8903C38.7319 31.3003 34.059 37.2632 27.575 37.2632C25.3961 37.2632 23.3486 36.1312 22.6483 34.7941C22.6483 34.7941 21.5699 38.8989 21.3078 39.9053C20.8553 41.6457 18.9185 45.2513 17.9462 46.889C20.1705 47.6075 22.5398 48 25 48C37.6826 48 48 37.6826 48 25C48 12.3179 37.6826 2 25 2Z"
        fill="currentColor"
      />
    </svg>
  );
};
